import { generatePath } from "react-router";

import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { SettingsSecurityContainer } from "@/components/features/settings/security";

import { useConfirmParams } from "./hooks";

export const SettingsSecurityPage = () => {
	const result = useConfirmParams();

	const { canRender } = result;
	if (!canRender) return <></>;

	const { hotelID } = result;

	return (
		<PageMeta title="セキュリティの設定" url={generatePath(PATHS.SETTINGS.SECURITY, { hotelID })}>
			<SettingsSecurityContainer />
		</PageMeta>
	);
};

SettingsSecurityPage.displayName = "SettingsSecurityPage";
